import React, { useState, useEffect, useCallback, useRef } from 'react';
import { AgGridReact } from 'ag-grid-react';
import Popup from 'reactjs-popup';
import NewGroup from './NewGroup';
import Confirmation from '../common/Confirmation';
import { GroupService } from '../../service/group.service';
import Loader from '../Loader';
import Alert from '../common/Alert';

import '../../../node_modules/reactjs-popup/dist/index.css';
import '../../../node_modules/ag-grid-community/styles/ag-grid.css';
import '../../../node_modules/ag-grid-community/styles/ag-theme-alpine.css';

const GroupList = (props) => {
    const gridRef = useRef();
    const [rowData, setRowData] = useState();
    const [loading, setLoading] = useState(true);
    const [isAlert, setIsAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [pageLoading, setPageLoading] = useState(false);

    const groupService = new GroupService();

    const gridCellRenderer = (params) => {
        if (params.value) {
            let _value = '<span title="' + params.value + '">' + params.value + '</span>';
            return <div dangerouslySetInnerHTML={{ __html: _value }}></div>;;
        }
    }

    const editCellRenderer = (params) => {
        return <Popup trigger={<i className="fa fa-edit"></i>} nested modal>{close => (<NewGroup id={params.data.id} callBack={reloding} onClose={() => { close(); }}></NewGroup>)}</Popup>;
    };

    const deleteCellRenderer = (params) => {
        return <Popup trigger={<i style={{ color: "#970000" }} className="fa fa-trash"></i>} nested modal>{close => (<Confirmation message={"Are you sure, you want to delete this group [" + params.data.name + "]?"} data={params.data.id} onSuccess={deleteGroup} onClose={() => { close(); }}></Confirmation>)}</Popup>;
    }

    const columnDefs = [
        { headerName: 'Name', field: 'name', filter: true, cellRenderer: p => gridCellRenderer(p), resizable: true },
        { headerName: 'Created', field: 'createdDate', width: 85, filter: false, cellRenderer: p => gridCellRenderer(p), resizable: false },
        { headerName: 'Created By', field: 'createdBy', filter: false, cellRenderer: p => gridCellRenderer(p), resizable: false },
        { headerName: 'Applications', field: 'applications', filter: false, cellRenderer: p => gridCellRenderer(p), resizable: true },
        { headerName: '', colId: 'edit-button', field: '', width: 30, sortable: false, suppressSizeToFit: true, cellRenderer: p => editCellRenderer(p), resizable: false },
        { headerName: '', colId: 'delete-button', field: '', width: 30, sortable: false, suppressSizeToFit: true, cellRenderer: p => deleteCellRenderer(p), resizable: false }
    ];
    
    useEffect(() => {
        if (loading == true) {
            setPageLoading(true);
            fetch('/api/group/getgroups')
                .then(result => result.json())
                .then(rowData => {
                    setRowData(rowData.data);
                    gridRef.current.api.sizeColumnsToFit();
                    setPageLoading(false);
                });
            setLoading(false);
        }
    }, [loading]);

    useEffect(() => {
        setLoading(props.loading);
    }, [props]);

    const deleteGroup = async (id) => {
        var delResult = await groupService.deleteGroup(id);
        if (delResult.data) {
            setAlertMessage(delResult.data.message);
            alertOn(true);
        };
    };

    const alertOff = () => {
        setIsAlert(false);
        reloding();
    };

    const alertOn = () => {
        setIsAlert(true);
    };

    const reloding = () => {
        setLoading(true);
    };

    const gridOptions = {
        columnDefs: columnDefs,
        pagination: true,
        rowSelection: 'single',
        enableFilter: true,
        cacheBlockSize: 25,
        paginationPageSize: 25,
        getRowHeight: (params) => 25
    }

    return (
        <>
            {isAlert && <div><Alert type="error" message={alertMessage} callBack={alertOff} /></div>}
            {pageLoading && <Loader />}
            <div className="ag-theme-alpine" style={{ height: "100%" }}>
                <AgGridReact
                    ref={gridRef}
                    rowData={rowData}
                    //onCellClicked={cellClickedListener}
                    gridOptions={gridOptions}
                />
            </div>
        </>
    );
};

export default GroupList;